export default __webpack_public_path__ + "8f9b4677107dccd04d7e0afd93504902.png";